import { render } from "./chartCard.vue?vue&type=template&id=0ddf70bd"
import script from "./chartCard.vue?vue&type=script&lang=js"
export * from "./chartCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__